import { AppStoreButton } from "../components/AppStoreButton";
import { RecordPreview } from "../components/RecordPreview";
import type { LandingContent, Locale } from "../content/types";

type HeroSectionProps = {
  content: LandingContent;
  locale: Locale;
};

export function HeroSection({ content, locale }: HeroSectionProps) {
  return (
    <section className="hero-section">
      <div className="page-container hero-grid">
        <div className="hero-copy">
          <img className="hero-icon" src="/images/moodshot-icon.svg" alt="" width="88" height="88" />
          <h1>{content.hero.title}</h1>
          <p>{content.hero.description}</p>
          <AppStoreButton label={content.hero.cta} unavailableLabel={content.hero.ctaUnavailable} locale={locale} />
          <small className="hero-note">{content.hero.note}</small>
        </div>
        <div className="hero-preview" aria-hidden="true">
          <RecordPreview state="record" label="" />
        </div>
      </div>
    </section>
  );
}
